export const PROPERTY_BLACKLIST = [
  'email',
  'Email',
  'firstName',
  'lastName',
  'phone',
  'LDAP',
];
